import { apiPost } from "../baseApi";
import { setDomainData } from "service/mapper";

export const create = async (data) => {
  try {
    const response = await apiPost("_domain", data);
    return { ...response, data: setDomainData(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
